import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import ContactStaff from '@components/Common/ContactStaff';
import { RootState } from '@Redux/search/store';
import { setCallJson } from '@Redux/search/actions';
import Pc from './subComponent/Pc';
import M from './subComponent/M';
import styles from './styles.module.scss';
import domainByEnv from '@utils/domainByEnv';
import fetchAPI from '@utils/fetchAPI';
const detailRoute = `${domainByEnv()}/detail`;

const ResultList = () => {
    const dispatch = useDispatch();
    const { SwitchListBy, callJson, SingleGroupListInfo } = useSelector(
        (state: RootState) => state.search
    );
    const [isContactStaffOpen, setIsContactStaffOpen] = useState<boolean>(false);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    const isList = SwitchListBy === 'Cards';

    useEffect(() => {
        // IT使用session打agent資料，因此不需傳值
        const fetchData = async () => {
            const res = await fetchAPI({ url: `${detailRoute}/calljson`, req: '' });
            dispatch(setCallJson(res));
        };
        if (SingleGroupListInfo?.isLoading === true) {
            return;
        }
        fetchData();
    }, [SingleGroupListInfo?.isLoading, dispatch]);

    return (
        <div className={cN('ResultList', styles.ResultList, { [`${styles.show}`]: isList })}>
            {isMobile ? (
                <M setIsContactStaffOpen={setIsContactStaffOpen} />
            ) : (
                <Pc setIsContactStaffOpen={setIsContactStaffOpen} />
            )}
            {/* 請洽專員光箱 */}
            <ContactStaff
                open={isContactStaffOpen}
                ToggleLightBox={() => {
                    setIsContactStaffOpen(false);
                }}
                callJson={callJson}
                origin="search"
            />
        </div>
    );
};

export default ResultList;
